import Text from "./Text.js";
import withValidation from "./withValidation.js";

export default withValidation(Text);
